// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

export const XngPopulateApiParameter = (props: any) => {
    if (!props.cartToUpdate) {
        return;
    }
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    const shipTo = getShipToState(state, cart ? cart.shipToId : undefined);
    const { requestedDeliveryDate } = state.pages.checkoutReviewAndSubmit;

    props.apiParameter = {
        cart: {
            ...props.cartToUpdate,
            requestedDeliveryDate: requestedDeliveryDate?.toISOString(),
            notes: props.parameter.cartNotes,
            properties: {
                ...props.cartToUpdate.properties,
                plumbers_placedByPhoneNumber: props.parameter?.plumbers_placedByPhoneNumber,
                plumbers_placedBy: props.parameter?.plumbers_placedBy,
                plumbers_rememberPhoneNumber: props.parameter?.plumbers_rememberPhoneNumber.toString(),
            },
        },
    };
};

// reset the optional requestedPickupDate
export const XngResetRequestedPickupDate = (props: any) => {
    props.dispatch({
        type: "Pages/CheckoutReviewAndSubmit/SetRequestedPickUpDate",
        requestedPickUpDate: null,
    });
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToEndOfChain(chain, XngResetRequestedPickupDate);
